import * as msal from "@azure/msal-browser";
import { ConfigMsal } from "configAuth";

export default class MsalFactory {
  private static msalInstance: msal.PublicClientApplication;

  public static build(): void {
    this.msalInstance = new msal.PublicClientApplication(ConfigMsal);
  }

  public static initialize(): Promise<void> {
    return this.msalInstance.initialize();
  }

  public static getMsalInstance(): msal.PublicClientApplication {
    if (!this.msalInstance) {
      throw Error("MSAL not initialized.");
    }

    return this.msalInstance;
  }

  public static logoutAllAccounts(postLogoutRedirectUri: string | null): void {
    const account = MsalFactory.getMsalInstance().getAllAccounts();
    localStorage.removeItem("user");

    account.forEach((a) => {
      const request: msal.EndSessionRequest = {
        account: a,
      };

      if (postLogoutRedirectUri) {
        request.postLogoutRedirectUri = postLogoutRedirectUri;
      }

      MsalFactory.getMsalInstance().logoutRedirect(request);
    });
  }
}
